import { __extends } from "tslib";
/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import { createContext, useContext, useMemo } from 'react';
export var SlardarContext = createContext({});
SlardarContext.displayName = 'SlardarContext';
var getWindow = function () { return (typeof window === 'object' ? window : null); };
var getDefaultSlardar = function () {
    var _a;
    var global = getWindow();
    if (!global)
        return;
    return (global['Slardar'] || global['SlardarHybrid'] || ((_a = global['SlardarLite']) === null || _a === void 0 ? void 0 : _a.client) || global['SlardarLite']);
};
// @internal
var SlardarInstance = /** @class */ (function () {
    function SlardarInstance() {
    }
    SlardarInstance.create = function (slardar) {
        if (slardar === void 0) { slardar = getDefaultSlardar(); }
        if (!slardar) {
            console.error('Slardar Instance Not Found!');
            return;
        }
        if (typeof slardar === 'function') {
            return new CommandArrayInstance(slardar);
        }
        else if ('$' in slardar) {
            return new LiteInstance(slardar);
        }
        else {
            return new ObjectInstance(slardar);
        }
    };
    SlardarInstance.prototype.jsErr = function (error, extra, react) {
        try {
            this._jsErr(error, extra, react);
        }
        catch (e) {
            console.error(e);
        }
    };
    SlardarInstance.prototype.get = function (key) {
        try {
            return this._get(key);
        }
        catch (e) {
            console.error(e);
        }
    };
    SlardarInstance.prototype.set = function (config) {
        try {
            this._set(config);
        }
        catch (e) {
            console.error(e);
        }
    };
    SlardarInstance.prototype.spaInit = function () {
        try {
            this._spaInit();
        }
        catch (e) {
            console.error(e);
        }
    };
    SlardarInstance.prototype.spaSend = function () {
        try {
            this._spaSend();
        }
        catch (e) {
            console.error(e);
        }
    };
    SlardarInstance.prototype.pv = function (pid) {
        try {
            pid && this._pv(pid);
        }
        catch (e) {
            console.error(e);
        }
    };
    return SlardarInstance;
}());
export { SlardarInstance };
var CommandArrayInstance = /** @class */ (function (_super) {
    __extends(CommandArrayInstance, _super);
    function CommandArrayInstance(slardar) {
        var _this = _super.call(this) || this;
        _this.slardar = slardar;
        return _this;
    }
    CommandArrayInstance.prototype._jsErr = function (error, extra, react) {
        this.slardar('captureException', error, extra, react);
    };
    CommandArrayInstance.prototype._set = function (config) {
        this.slardar('set', config);
    };
    CommandArrayInstance.prototype._spaInit = function () {
        this.slardar('performanceInit');
    };
    CommandArrayInstance.prototype._spaSend = function () {
        this.slardar('performanceSend');
    };
    CommandArrayInstance.prototype._pv = function (pid) {
        this.slardar('sendPageview', pid);
    };
    CommandArrayInstance.prototype._get = function (key) {
        var _a;
        return (_a = this.slardar('config')) === null || _a === void 0 ? void 0 : _a[key];
    };
    return CommandArrayInstance;
}(SlardarInstance));
var LiteInstance = /** @class */ (function (_super) {
    __extends(LiteInstance, _super);
    function LiteInstance(slardar) {
        var _this = _super.call(this) || this;
        _this.slardar = slardar;
        _this.startTime = 0;
        if (!slardar.sender) {
            var sender_1;
            var cache_1 = [];
            Object.defineProperty(slardar, 'sender', {
                get: function () {
                    return sender_1 || (function (val) { return cache_1.push(val); });
                },
                set: function (val) {
                    sender_1 = val;
                    while (cache_1.length) {
                        val(cache_1.shift());
                    }
                },
            });
        }
        return _this;
    }
    LiteInstance.normalize = function (error) {
        return ['message', 'name', 'fileName', 'lineNumber', 'columnNumber', 'stack', 'stacktrace', 'framesToPop'].reduce(function (sum, cur) {
            sum[cur] = error[cur];
            return sum;
        }, {});
    };
    LiteInstance.prototype._jsErr = function (error, extra, react) {
        var _a, _b;
        (_b = (_a = this.slardar).sender) === null || _b === void 0 ? void 0 : _b.call(_a, {
            ev_type: 'js_error',
            payload: {
                error: LiteInstance.normalize(error),
                extra: extra,
                breadcrumbs: [],
                react: react,
            },
        });
    };
    LiteInstance.prototype._set = function (config) {
        Object.assign(this.slardar.config, config);
    };
    LiteInstance.prototype._pv = function (pid) {
        var _a, _b;
        (_b = (_a = this.slardar).sender) === null || _b === void 0 ? void 0 : _b.call(_a, {
            ev_type: 'pageview',
            payload: {
                pid: pid,
                source: 'user-set',
            },
        });
    };
    LiteInstance.prototype._spaInit = function () {
        this.startTime = Date.now();
    };
    LiteInstance.prototype._spaSend = function () {
        var _a, _b;
        (_b = (_a = this.slardar).sender) === null || _b === void 0 ? void 0 : _b.call(_a, {
            ev_type: 'performance',
            payload: {
                name: 'spa_load',
                value: Date.now() - this.startTime,
                type: 'spa',
            },
        });
    };
    LiteInstance.prototype._get = function (key) {
        return this.slardar.config[key];
    };
    return LiteInstance;
}(SlardarInstance));
var ObjectInstance = /** @class */ (function (_super) {
    __extends(ObjectInstance, _super);
    function ObjectInstance(slardar) {
        var _this = _super.call(this) || this;
        _this.slardar = slardar;
        return _this;
    }
    ObjectInstance.prototype._jsErr = function (error, extra, react) {
        var _a, _b;
        (_b = (_a = this.slardar).captureException) === null || _b === void 0 ? void 0 : _b.call(_a, error, extra, react);
    };
    ObjectInstance.prototype._set = function (config) {
        this.slardar.set(config);
    };
    ObjectInstance.prototype._spaInit = function () {
        var _a, _b;
        (_b = (_a = this.slardar).performanceInit) === null || _b === void 0 ? void 0 : _b.call(_a);
    };
    ObjectInstance.prototype._spaSend = function () {
        var _a, _b;
        (_b = (_a = this.slardar).performanceSend) === null || _b === void 0 ? void 0 : _b.call(_a);
    };
    ObjectInstance.prototype._pv = function (pid) {
        var _a, _b;
        (_b = (_a = this.slardar).sendPageview) === null || _b === void 0 ? void 0 : _b.call(_a, pid);
    };
    ObjectInstance.prototype._get = function (key) {
        var _a;
        return (_a = this.slardar.config()) === null || _a === void 0 ? void 0 : _a[key];
    };
    return ObjectInstance;
}(SlardarInstance));
export var useSlardar = function (slardarInstance) {
    var slardar = useContext(SlardarContext).Slardar;
    return useMemo(function () {
        return SlardarInstance.create(slardarInstance || slardar);
    }, [slardar, slardarInstance]);
};
//# sourceMappingURL=slardar.js.map